import React, {FC} from "react";
import {Badge, Flex, Link, LinkProps, Text} from "@chakra-ui/react";
import {useInactiveOrderReminderPendingCount} from "../../hooks/useInactiveOrderReminderPendingCount";
import {formatInactiveOrderReminderPendingBadge} from "../../shared/utils/inactiveOrderReminderPendingBadge";

const navLinkStyles = {
    color: "black.500",
    fontFamily: "Poppins",
    fontWeight: "400",
    lineHeight: "20px",
    textDecoration: "none",
    marginRight: "5px",
    cursor: "pointer",
    _hover: {
        textDecoration: "underline",
        color: "blue.600",
    },
};

type Props = {
    onNavigate: () => void;
    fontSize?: number | string;
    fontWeight?: string;
    pl?: number;
} & Pick<LinkProps, "onClick">;

export const InactiveOrderReminderNavLink: FC<Props> = ({
    onNavigate,
    fontSize = 14,
    fontWeight = "sm",
    pl = 1,
}) => {
    const pendingCount = useInactiveOrderReminderPendingCount();
    const badgeText = formatInactiveOrderReminderPendingBadge(pendingCount);

    return (
        <Link {...navLinkStyles} pl={pl} onClick={onNavigate}>
            <Flex align="center" display="inline-flex">
                <Text fontSize={fontSize} fontWeight={fontWeight} whiteSpace="nowrap">
                    Order reminders
                </Text>
                {badgeText != null && (
                    <Badge
                        ml={1}
                        bg="red.500"
                        color="white"
                        borderRadius="full"
                        minW="18px"
                        h="18px"
                        px={badgeText.length > 2 ? 1 : 0}
                        fontSize="10px"
                        fontWeight="bold"
                        lineHeight="18px"
                        textAlign="center"
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {badgeText}
                    </Badge>
                )}
            </Flex>
        </Link>
    );
};

export default InactiveOrderReminderNavLink;
